import React, { useState } from 'react';
import FormSearch from './../../composant/FormSearch';
import logo from './../../assets/images/estilizado.png';

export default function NavMenuAdmin() {
  const [menuAberto, setMenuAberto] = useState(false);
  const [searchAberto, setSearchAberto] = useState(false);

  const toggleMenu = () => setMenuAberto(!menuAberto);
  const toggleSearch = () => setSearchAberto(!searchAberto);

  const navLinks = [
    { href: '/', label: 'Início' },
    { href: '/loja', label: 'Loja' },
    { href: '/menu-rodizio', label: 'Cardápio' },
    { href: '/receitas', label: 'Receitas' },
    { href: '/contato', label: 'Contato' },
    { href: '/sobre', label: 'Sobre' },
    { href: '/noticias', label: 'Notícias' },
    { href: '/#order', label: 'Eventos/Festas' }
  ];

  return (
    <>
      <header className="flex items-center justify-between px-4 py-3 bg-red-700 text-white shadow-md">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2">
          <img src={logo} alt="Logo" className="h-10" />
          <span className="text-lg font-bold hidden md:inline">Painel Admin</span>
        </a>

        {/* Menu (desktop) */}
        <nav className="hidden md:flex space-x-4">
          {navLinks.map((link, i) => (
            <a key={i} href={link.href} className="hover:text-yellow-300 font-medium">
              {link.label}
            </a>
          ))}
        </nav>

        {/* Ações e Ícones */}
        <div className="flex items-center gap-4">
          <i className="fas fa-search cursor-pointer hover:text-yellow-300" onClick={toggleSearch}></i>
          <a href="#" className="hover:text-yellow-300"><i className="fa-solid fa-heart"></i></a>
          <a href="#" className="hover:text-yellow-300"><i className="fas fa-shopping-cart"></i></a>
          <i className="fa-solid fa-user hover:text-yellow-300"></i>

          {/* Menu burger (mobile) */}
          <button onClick={toggleMenu} className="md:hidden">
            <i className={`fas fa-${menuAberto ? 'times' : 'bars'} text-xl`}></i>
          </button>
        </div>
      </header>

      {/* Menu mobile */}
      {menuAberto && (
        <nav className="md:hidden bg-red-600 text-white px-4 py-2 space-y-2">
          {navLinks.map((link, i) => (
            <a key={i} href={link.href} className="block py-1 hover:text-yellow-300">
              {link.label}
            </a>
          ))}
        </nav>
      )}

      {/* Formulário de busca */}
      {searchAberto && (
        <form id="search-form" className="bg-white flex items-center px-4 py-3 border-b">
          <input
            type="search"
            placeholder="Pesquisar aqui..."
            className="flex-1 border border-gray-300 rounded px-3 py-2 focus:outline-none"
          />
          <i className="fas fa-times ml-2 text-red-700 cursor-pointer" onClick={toggleSearch}></i>
        </form>
      )}

      {/* Componente adicional se necessário */}
      <FormSearch />
    </>
  );
}
